<template>
    <div class="">
        <v-select
            v-model="employee"
            ref="empSelect"
            label="EmployeeId"
            :filterable="false"
            @search="onSearch"
            @input="onChange"
            :options="options"
            :placeholder="`Search ${placeholder}`"
            :class="{'filter-select': forFilters, 'is-invalid': hasError}"
            :disabled="disabled">
            <template slot="no-options">
                Search for Employee(s) by First Name, Last Name, or Employee#
            </template>
            <template slot="option" slot-scope="option">
                <div class="d-center">
                    {{ option.FirstName }} {{ option.LastName }}
                    <span v-if="filters && filters.has_email == true"> - {{ option.email }}</span>
                    <span v-else-if="option.EmployeeNumber"> - {{ option.EmployeeNumber }}</span>
                </div>
            </template>
            <template slot="selected-option" slot-scope="option">
                <div class="selected d-center">
                    {{ option.FirstName }} {{ option.LastName }}
                    <span v-if="filters && filters.has_email == true"> - {{ option.email }}</span>
                    <span v-else-if="option.EmployeeNumber"> - {{ option.EmployeeNumber }}</span>
                </div>
            </template>
        </v-select>
    </div>
</template>

<script>
    export default {
        props: {
            selectedValues: {
                type: Object,
                default: null
            },

            forFilters: {
                type: Boolean,
                default: false,
            },

            excludeId: {
                type: Number,
            },

            placeholder: {
                type: String,
                default: 'Employees',
            },

            hasError: {
                type: Boolean,
                default: false,
            },

            filters: {
                type: Object,
                default: null
            },

            disabled: {
                type: Boolean,
                default: false,
            },
        },

        data: function() {
            return {
                options: [],
                employee: null,
            }
        },

        watch: {
            //Watcher for errors
            hasError(newValue, oldValue){
                //Set it
                this.hasError = newValue;
            },

            selectedValues(newValue, oldValue){
                if(newValue != null && Object.keys(newValue).length > 0 && !this.employee)
                {
                    this.options.push(newValue);
                    this.employee = newValue;
                }
            }
        },

        methods: {
            //Search
            onSearch(searchTerm, searchLoading){
                //Done loading
                searchLoading(true);

                //Send it
                this.$http.get('/employees/search', {term: searchTerm, excludeId: this.excludeId, filters: this.filters})
                    .then(res => {
                        //Set the data
                        this.options = res.data;

                        //Done loading
                        searchLoading(false);
                    });
            },

            setSelectedValues(employee){
                //Set the value
                this.employee = employee;
            },

            //Emit the event
            onChange(employee) {
                //Make sure we're not loading
                if (!this.loading)
                {
                    //Send it
                    this.$emit('vselected', employee);
                }
            },

            clearInput(){
                //Set to null
                this.employee = null;
                this.options = [];
                this.$refs.empSelect.clearSelection();
            },

            setFocus(){
                this.$refs.empSelect.$refs.search.focus();
            },
        },

        mounted() {
            if(this.selectedValues != null && Object.keys(this.selectedValues).length > 0)
            {
                this.options.push(this.selectedValues);
                this.employee = this.selectedValues;
            }
        }
    }
</script>

<style scoped>
    .filter-select {
        background-color: #fff;
    }

    .filter-select.open >>> .selected-tag {
        margin-top: 3px;
    }

    .filter-select >>> .dropdown-toggle {
        border: 1px solid #c6c6c6;
        max-height: 31px;
        margin-top: -1px;
        padding: 1px 0 3px 0;
    }

    .filter-select >>> .selected-tag {
        margin: 3px 0 0 0;
        padding-left: 5px;
        white-space: nowrap;
        overflow: hidden;
        width: 200px;
    }

    .filter-select >>> .vs__actions button {
        margin-top: 3px;
    }

    .vs__search::placeholder,
    .vs__dropdown-toggle,
    .vs__dropdown-menu {
      background: #dfe5fb;
      border: none;
      color: #394066;
      text-transform: lowercase;
      font-variant: small-caps;
    }

    .vs__clear,
    .vs__open-indicator {
      fill: #394066;
    }

    .v-select.disabled .dropdown-toggle,
    .v-select.disabled .dropdown-toggle .clear,
    .v-select.disabled .dropdown-toggle input,
    .v-select.disabled .open-indicator,
    .v-select.disabled .selected-tag .close {
        margin-top: 0;
        overflow-y: hidden;
    }
</style>